import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

export enum zohoAuthType {
    accessToken = 'Access Token',
    OAuth_2_0 = 'OAuth_2.0'
}

@Metamodel.model({
    name: 'Zoho',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Zoho_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Zoho_DisplayText)
    ]
})
export class ZohoLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Endpoint
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessToken,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accessToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean;

    public authType?: zohoAuthType = zohoAuthType.accessToken;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_RefreshToken
    })
    public refreshToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccountsUrl
    })
    public accountsUrl?: string;

    public isOldResource: boolean = false;

    public isLegacyConnector: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
